import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/parking-guest-reason/:id/';

interface DTO {
    parkingId: string;
    id: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, id }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_PARKING_GUEST_REASON_RESOURCE, useMutationHook as useDeleteParkingGuestReason };
export type { DTO as DeleteParkingGuestReasonDTO };
